export type TaskSlackInfo = any;
export type ICalendarRule = any;
export type CalendarConfig = any;
export type ICalendar = any;
export const Calendar = null as any;
